(() => {
  const ELEMENT_NAME = 'custom-announcement-bar';
  const DEFAULT_COOLDOWN_HOURS = 24;
  const STORAGE_PREFIX = 'cab_dismiss_';

  if (!window.customElements) return;
  if (customElements.get(ELEMENT_NAME)) return;

  class CustomAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this._onCloseClick = this._onCloseClick.bind(this);
      this._onActionClick = this._onActionClick.bind(this);

      this._bar = null;
      this._closeBtn = null;
      this._actionBtn = null;
      this._storageKey = '';
      this._cooldownHours = DEFAULT_COOLDOWN_HOURS;
      this._visible = true;
    }

    connectedCallback() {
      try {
        const enabled = this.getAttribute('data-enabled');
        if (enabled === 'false') {
          // hide by removing 'show' if present
          if (this.classList.contains('show')) this.classList.remove('show');
          return;
        }

        const attrCooldown = this.getAttribute('data-cooldown-hours');
        const parsedCd = Number(attrCooldown);
        this._cooldownHours = (attrCooldown !== null && !Number.isNaN(parsedCd) && parsedCd >= 0)
          ? parsedCd
          : DEFAULT_COOLDOWN_HOURS;

        this._storageKey = STORAGE_PREFIX + (this.id || this.getAttribute('data-storage-key') || `default_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);

        // If still in cooldown, hide and exit
        if (!this._shouldShowBasedOnCooldown()) {
          // hide by removing 'show' if present
          if (this.classList.contains('show')) this.classList.remove('show');
          this._visible = false;
          return;
        }

        this._bar = this.querySelector('.cab-bar');
        this._closeBtn = this.querySelector('.cab-close');
        this._actionBtn = this.querySelector('.cab-button');

        // Ensure visible by default (add 'show' class)
        if (!this.classList.contains('show')) this.classList.add('show');
        this._visible = true;
        this.setAttribute('aria-hidden', 'false');

        if (this._closeBtn) this._closeBtn.addEventListener('click', this._onCloseClick);
        if (this._actionBtn) this._actionBtn.addEventListener('click', this._onActionClick);

        // Public API: dismiss programmatically
        this.dismiss = () => { this._persistAndHide(); };
      } catch (e) {
        // Fail silently to avoid breaking storefront
      }
    }

    disconnectedCallback() {
      try {
        if (this._closeBtn) this._closeBtn.removeEventListener('click', this._onCloseClick);
        if (this._actionBtn) this._actionBtn.removeEventListener('click', this._onActionClick);
      } catch (e) {}
    }

    /* Storage helpers */
    _readStoredTs() {
      try {
        const raw = localStorage.getItem(this._storageKey);
        if (!raw) return null;
        const ts = parseInt(raw, 10);
        return Number.isFinite(ts) ? ts : null;
      } catch (e) {
        return null;
      }
    }

    _writeStoredTs(ts) {
      try {
        localStorage.setItem(this._storageKey, String(ts));
        return true;
      } catch (e) {
        return false;
      }
    }

    _shouldShowBasedOnCooldown() {
      const ts = this._readStoredTs();
      if (!ts) return true;
      const elapsed = Date.now() - ts;
      const cooldownMs = Number(this._cooldownHours) * 3600 * 1000;
      return elapsed >= cooldownMs;
    }

    /* Persist + hide */
    _persistAndHide() {
      try {
        this._writeStoredTs(Date.now());
      } catch (e) {
        // ignore storage failures
      }
      this._hide();
    }

    _hide() {
      // hide by removing 'show' class if present
      if (this.classList.contains('show')) this.classList.remove('show');
      if (this._bar) this._bar.setAttribute('data-visible', 'false');
      this.setAttribute('aria-hidden', 'true');
      this._visible = false;
    }

    /* Handlers */
    _onCloseClick(e) {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      this._persistAndHide();
    }

    _onActionClick(e) {
      // Persist immediately before the link/navigation happens
      try { this._writeStoredTs(Date.now()); } catch (err) {}
      // Hide the bar (do not prevent navigation)
      this._hide();
    }
  }

  customElements.define(ELEMENT_NAME, CustomAnnouncementBar);
})();